module.exports = __webpack_public_path__ + "static/media/unimed-inconfidentes.cafec9a9.png";